import { handleHttpResponse } from "../../utils/http_response_utils";

export const getNatgwData = async () => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/get-nat-gateway-status", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return await handleHttpResponse(response);
};

export const deleteNatgw = async (natgatewayName) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/delete-nat-gateway", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ nat_gateway_name: natgatewayName }),
  });
  return await handleHttpResponse(response);
};

export const createNatgw = async (natgatewayName) => {
  const accessToken = localStorage.getItem("access-token");
  const response = await fetch("/api/create-nat-gateway", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ nat_gateway_name: natgatewayName }),
  });
  return await handleHttpResponse(response);
};
